import {
  remapGenericParagraphSpeakers,
  usesGenericSpeakers,
} from "DAIEditor/config/speakerSettings";
import {
  concatTranscriptPages,
  fetchRemainingTranscriptPages,
  nextTranscriptPageStart,
} from "./transcriptPages";

/**
 * Load the full server transcript after a 409. Does not touch Redux: the
 * caller must initialize the store, bump version, and force-replace Slate
 * only after this returns a non-empty merge.
 */
export async function reloadTranscriptAfterConflict(
  id,
  { getWorkflowTranscript, getPaginatedWorkflowTranscript }
) {
  const fresh = await getWorkflowTranscript(id);
  const prefix = fresh?.transcript?.transcript || [];
  const rest = await fetchRemainingTranscriptPages(
    id,
    nextTranscriptPageStart(prefix),
    getPaginatedWorkflowTranscript
  );
  let mergedList = concatTranscriptPages(prefix, rest.items);

  if (usesGenericSpeakers(fresh?.assignees || [])) {
    mergedList = remapGenericParagraphSpeakers(
      mergedList,
      fresh?.processed_data?.speakers || []
    );
  }

  if (!mergedList.length) {
    throw new Error("Empty transcript");
  }

  return {
    fresh,
    mergedList,
    version: fresh?.processed_data?.version || 1,
    hitPageCap: Boolean(rest.hitPageCap),
  };
}
